export default {"src":"/_next/static/media/mochipay-circle-color.b8493480.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};